import { render, staticRenderFns } from "./remember-section.vue?vue&type=template&id=6740f084"
import script from "./remember-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./remember-section.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports